import React from 'react';
import { BrowserRouter as Router, Redirect, Route} from 'react-router-dom';
import { BackToTop } from './components';
import { BlogPage, HomePage, ProjectPage } from './pages';
import ScrollToTop from './utils/ScrollToTop';
import CampaignBanner from './pages/Misc/CampaignBanner';
import { LoadingSpinner } from './common/components/UIElements/loadingAnimations';
import './App.css';
import Footer from './components/Footer/Footer';
import ChangeTheme from './components/ChangeTheme/ChangeTheme';

function App() {

  return (
    <div className="app">
    
      <Router>
      <React.Suspense fallback={<LoadingSpinner />}>
        <ScrollToTop />
        
        <CampaignBanner/>
        <Route>
                 
          <Route path="/" exact component={HomePage} />
          <Route path="/blog" exact component={BlogPage} />
          <Route path="/projects" exact component={ProjectPage} />

          <Redirect to="/" />
         </Route>
         </React.Suspense>
         <Footer />
      </Router>
      
      
      <BackToTop />
      <ChangeTheme />
    </div>
  );
}

export default App;
